import Bugsnag from '@bugsnag/js';

export function log(message: string) {
  Bugsnag.notify(message);
  console.error(message);
}
